module.exports = __webpack_public_path__ + "static/media/residents-hero.f1e0c5d1.jpg";